<!-- 产品属性 -->
<template>
    <div v-if="componentsData.type == 13">
        <div
            class="overflow-hidden bg-div"
            :style="
                componentsData.content.version
                    ? {
                          ...(componentsData.content.bg_color && {
                              backgroundColor: componentsData.content.bg_color,
                          }),
                          ...(componentsData.content.bg_img.picview &&
                              componentsData.content.bg_value && {
                                  backgroundImage: `url(${componentsData.content.bg_img.picview})`,
                              }),
                          padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                          margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                          borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`,
                      }
                    : `background: ${componentsData.content.bg_color};padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px`
            "
        >
            <template v-if="componentsData.content.title">
                <div
                    class="flex-c fw-bold"
                    v-if="componentsData.content.style_value == 1"
                    :style="`border-bottom: 1px solid ${componentsData.content.title_border_color};
                        background: ${componentsData.content.title_bg_color}; font-size: ${componentsData.content.title_size}px; color: ${componentsData.content.title_color};
                    `"
                >
                    <div
                        class="dec-left"
                        :style="{ background: decLeft }"
                    ></div>
                    <div class="dec-content">
                        {{ componentsData.content.title }}
                    </div>
                    <div
                        class="dec-right"
                        :style="{ background: decRight }"
                    ></div>
                </div>
                <div
                    v-else
                    class="fw-bold"
                    :style="`text-align: ${componentsData.content.position};border-bottom: 1px solid ${componentsData.content.title_border_color};
                        background: ${componentsData.content.title_bg_color}; font-size: ${componentsData.content.title_size}px; color: ${componentsData.content.title_color};
                    `"
                >
                    {{ componentsData.content.title }}
                </div>
            </template>
            <!-- 内容 -->
            <div
                v-if="
                    componentsData.content.style_value == 1 ||
                    componentsData.content.style_value == 2
                "
                :style="`font-size: ${componentsData.content.text_size}px; color: ${componentsData.content.text_color};`"
            >
                <div>
                    <span
                        :style="` font-size: ${componentsData.content.text_size}px; color: ${componentsData.content.text_color};`"
                        >属性名称：</span
                    >
                    <span
                        :style="`font-size: ${componentsData.content.txt_size}px; color: ${componentsData.content.txt_color};`"
                        >属性内容</span
                    >
                </div>
                <div class="pt-6">
                    <span
                        :style="` font-size: ${componentsData.content.text_size}px; color: ${componentsData.content.text_color}; `"
                        >属性名称：
                    </span>
                    <span
                        :style="` font-size: ${componentsData.content.txt_size}px; color: ${componentsData.content.txt_color}; `"
                        >属性内容</span
                    >
                </div>
            </div>
            <div v-else>
                <div class="box-div">
                    <div
                        class="box mr-6"
                        :style="`border-bottom: 1px solid ${componentsData.content.border_color};`"
                    >
                        <div
                            :style="`font-size: ${componentsData.content.text_size}px; color: ${componentsData.content.text_color};`"
                        >
                            属性名称
                        </div>
                        <div
                            :style="`font-size: ${componentsData.content.txt_size}px; color: ${componentsData.content.txt_color};`"
                            class="mtb-6"
                        >
                            属性内容
                        </div>
                    </div>
                    <div
                        class="box ml-6"
                        :style="`border-bottom: 1px solid ${componentsData.content.border_color};`"
                    >
                        <div
                            :style="` font-size: ${componentsData.content.text_size}px; color: ${componentsData.content.text_color};`"
                        >
                            属性名称
                        </div>
                        <div
                            :style="`font-size: ${componentsData.content.txt_size}px; color: ${componentsData.content.txt_color};`"
                            class="mtb-6"
                        >
                            属性内容
                        </div>
                    </div>
                </div>
                <div class="box-div mt12">
                    <div
                        class="box mr-6"
                        :style="`border-bottom: 1px solid ${componentsData.content.border_color};`"
                    >
                        <div
                            :style="` font-size: ${componentsData.content.text_size}px; color: ${componentsData.content.text_color};`"
                        >
                            属性名称
                        </div>
                        <div
                            :style="`font-size: ${componentsData.content.txt_size}px; color: ${componentsData.content.txt_color};`"
                            class="mtb-6"
                        >
                            属性内容
                        </div>
                    </div>
                    <div
                        class="box ml-6"
                        :style="`border-bottom: 1px solid ${componentsData.content.border_color};`"
                    >
                        <div
                            :style="` font-size: ${componentsData.content.text_size}px; color: ${componentsData.content.text_color};`"
                        >
                            属性名称
                        </div>
                        <div
                            :style="`font-size: ${componentsData.content.txt_size}px; color: ${componentsData.content.txt_color};`"
                            class="mtb-6"
                        >
                            属性内容
                        </div>
                    </div>
                </div>
                <div class="box-div mt12">
                    <div
                        class="box mr-6"
                        :style="`border-bottom: 1px solid ${componentsData.content.border_color};`"
                    >
                        <div
                            :style="` font-size: ${componentsData.content.text_size}px; color: ${componentsData.content.text_color};`"
                        >
                            属性名称
                        </div>
                        <div
                            :style="`font-size: ${componentsData.content.txt_size}px; color: ${componentsData.content.txt_color};`"
                            class="mtb-6"
                        >
                            属性内容
                        </div>
                    </div>
                    <div
                        class="box ml-6"
                        :style="`border-bottom: 1px solid ${componentsData.content.border_color};`"
                    >
                        <div
                            :style="` font-size: ${componentsData.content.text_size}px; color: ${componentsData.content.text_color};`"
                        >
                            属性名称
                        </div>
                        <div
                            :style="`font-size: ${componentsData.content.txt_size}px; color: ${componentsData.content.txt_color};`"
                            class="mtb-6"
                        >
                            属性内容
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    computed: {
        decLeft() {
            return `linear-gradient(to left, ${this.componentsData.content.dec_color}, transparent)`;
        },
        decRight() {
            return `linear-gradient(to right, ${this.componentsData.content.dec_color}, transparent)`;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.overflow-hidden {
    overflow: hidden;
}
.fw-bold {
    font-weight: bold;
    padding-bottom: 6px;
    margin-bottom: 6px;
}
.pt-6 {
    padding: 6px 0 0 0;
}
.dec-left {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-right {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-content {
    max-width: 200px;
    white-space: nowrap; /* 确保文本不会换行 */
    overflow: hidden; /* 隐藏溢出的文本 */
    text-overflow: ellipsis; /* 显示省略号来代表被修剪的文本 */
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.box-div {
    display: flex;
    padding-top: 12px;
}
.box {
    width: 50%;
}
.ml-6 {
    margin-left: 6px;
}
.mr-6 {
    margin-right: 6px;
}
.mtb-6 {
    margin: 3px 0 6px 0;
}
</style>